// extracted by mini-css-extract-plugin
export default {"page__content":"PageContainer_page__content__limEs","page__container":"PageContainer_page__container__n4pzG"};